// card-sibling-swatches.js
// ========================
// Handles color swatch clicking on collection page product cards.
// Swaps card image, title, price, color name, tag, and URL without page reload.
// Delegated click listener on document — works for dynamically added cards.

(function() {
  'use strict';

  // Once-guard: prevents duplicate delegated listeners if the file is ever
  // loaded twice (e.g. a stale per-card tag surviving alongside the global load).
  if (window.__cardSwatchInit) return;
  window.__cardSwatchInit = true;

  var WIDTHS = [200, 300, 400, 500, 600, 700, 800, 900, 1000, 1200, 1400, 1600];

  function makeSrcset(url) {
    return WIDTHS.map(function(w) {
      return url.replace(/width=\d+/, 'width=' + w) + ' ' + w + 'w';
    }).join(', ');
  }

  document.addEventListener('click', function(e) {
    var swatch = e.target.closest('[data-sibling-swatch]');
    if (!swatch) return;

    e.preventDefault();

    var card = swatch.closest('product-card');
    if (!card) return;

    /* 1 — Toggle selection */
    card.querySelectorAll('[data-sibling-swatch]').forEach(function(s) {
      s.classList.remove('is-selected');
    });
    swatch.classList.add('is-selected');

    /* 2 — Read data */
    var url       = swatch.getAttribute('data-url');
    var title     = (swatch.getAttribute('data-title') || '').split(' - ')[0];
    var price     = swatch.getAttribute('data-price');
    var cmpPrice  = swatch.getAttribute('data-compare-price');
    var priceRaw  = parseInt(swatch.getAttribute('data-price-raw') || '0', 10);
    var cmpRaw    = parseInt(swatch.getAttribute('data-compare-raw') || '0', 10);
    var onSale    = cmpRaw > 0 && cmpRaw > priceRaw;
    var imgUrl    = swatch.getAttribute('data-image');
    var imgAlt    = swatch.getAttribute('data-image-alt');
    var imgW      = swatch.getAttribute('data-image-width');
    var imgH      = swatch.getAttribute('data-image-height');
    var secImgUrl = swatch.getAttribute('data-secondary-image');
    var secImgAlt = swatch.getAttribute('data-secondary-image-alt');

    /* 3 — Swap primary image */
    var priImg = card.querySelector('.product-card__image--primary');
    if (priImg && imgUrl) {
      priImg.src = imgUrl;
      priImg.srcset = makeSrcset(imgUrl);
      priImg.alt = imgAlt || title;
      if (imgW) priImg.width = imgW;
      if (imgH) priImg.height = imgH;
    }

    /* 4 — Swap secondary (hover) image */
    var secImg = card.querySelector('.product-card__image--secondary');
    if (secImg) {
      if (secImgUrl) {
        secImg.src = secImgUrl;
        secImg.srcset = makeSrcset(secImgUrl);
        secImg.alt = secImgAlt || title;
        secImg.style.removeProperty('display');
      } else {
        secImg.style.display = 'none';
      }
    }

    /* 5 — Update title */
    var titleEl = card.querySelector('.product-title');
    if (titleEl && title) {
      titleEl.textContent = title;
    }

    /* 6 — Update color name */
    var colorName = swatch.getAttribute('data-color-name');
    var colorNameEl = card.querySelector('[data-card-color-name]');
    if (colorNameEl && colorName) {
      colorNameEl.textContent = colorName;
    }

    /* 7 — Update product tag (BEST SELLER, NEW ARRIVAL, etc.) */
    var tagName  = swatch.getAttribute('data-tag-name');
    var tagColor = swatch.getAttribute('data-tag-color');
    var tagEl    = card.querySelector('[data-card-tag-name]');
    if (tagEl) {
      if (tagName) {
        tagEl.textContent = tagName;
        tagEl.style.display = 'block';
        tagEl.style.color = tagColor || '';
      } else {
        tagEl.textContent = '';
        tagEl.style.display = 'none';
      }
    }

    /* 8 — Update price */
    var priceList = card.querySelector('price-list');
    if (priceList && price) {
      var sp = priceList.querySelector('sale-price');
      var cp = priceList.querySelector('compare-at-price');

      if (sp) {
        var sr = sp.querySelector('.sr-only');
        sp.textContent = '';
        if (sr) sp.appendChild(sr);
        sp.append(price);

        sp.className = sp.className.replace(/text-on-sale|text-subdued/g, '').trim();
        sp.classList.add(onSale ? 'text-on-sale' : 'text-subdued');
      }

      if (onSale && cmpPrice) {
        if (cp) {
          var csr = cp.querySelector('.sr-only');
          cp.textContent = '';
          if (csr) cp.appendChild(csr);
          cp.append(cmpPrice);
          cp.style.removeProperty('display');
        } else {
          var nc = document.createElement('compare-at-price');
          nc.className = 'line-through';
          nc.innerHTML = '<span class="sr-only">Regular price</span>' + cmpPrice;
          priceList.appendChild(nc);
        }
      } else if (cp) {
        cp.style.display = 'none';
      }
    }

    /* 9 — Update all card links (except swatches) */
    if (url) {
      card.querySelectorAll('a[href]').forEach(function(link) {
        if (link.hasAttribute('data-sibling-swatch')) return;
        if (link.closest('.product-card__swatch-list')) return;
        link.href = url;
      });
    }

    /* 10 — Update card handle */
    if (url && card.hasAttribute('handle')) {
      card.setAttribute('handle', url.split('/products/').pop().split('?')[0]);
    }

    /* 11 — Update wishlist bookmark data attributes
       Keeps the [data-wishlist-toggle] button in sync with the
       currently-displayed sibling so Swym receives the correct
       product ID, variant ID, price, title, image, and URL.     */
    var wlBtn = card.querySelector('[data-wishlist-toggle]');
    if (wlBtn) {
      var sibId    = swatch.getAttribute('data-product-id');
      var sibVarId = swatch.getAttribute('data-variant-id');
      var sibUrl   = swatch.getAttribute('data-product-url');

      if (sibId)    wlBtn.setAttribute('data-product-id', sibId);
      if (sibVarId) wlBtn.setAttribute('data-variant-id', sibVarId);
      if (sibUrl)   wlBtn.setAttribute('data-product-url', window.location.origin + sibUrl);
      if (title)    wlBtn.setAttribute('data-product-title', swatch.getAttribute('data-title') || title);
      if (imgUrl)   wlBtn.setAttribute('data-product-image', imgUrl.replace('width=1600', 'width=600'));
      if (priceRaw) wlBtn.setAttribute('data-product-price', (priceRaw / 100).toFixed(2));

      /* Reset saved state — the new sibling may not be in wishlist.
         wishlist-bookmarks.js MutationObserver will re-sync via Swym. */
      wlBtn.classList.remove('is-saved');
      wlBtn.setAttribute('aria-label', 'Add to wishlist');

      /* Dispatch sync event so wishlist-bookmarks.js re-checks Swym
         (attribute-only changes don't trigger its MutationObserver). */
      document.dispatchEvent(new CustomEvent('wishlist:sync'));
    }
  }); /* bubble phase — preventDefault stops navigation; analytics listeners on parents still fire */
})();